var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94444 19.4444C5.83333 19.4444 4.72222 18.4722 4.16667 18.0556C1.38889 16.1111 0.555556 15.4167 0 15V20.8333C0 21.6003 0.621962 22.2222 1.38889 22.2222H12.5C13.2669 22.2222 13.8889 21.6003 13.8889 20.8333V15C13.3333 15.4167 12.5 16.1111 9.72222 18.0556C9.16667 18.4722 8.05556 19.4444 6.94444 19.4444ZM12.5 11.1111H1.38889C0.621962 11.1111 0 11.7331 0 12.5V13.1944C1.11111 14.0278 0.972222 14.0278 5 16.9444C5.41667 17.2222 6.25 18.0556 6.94444 18.0556C7.63889 18.0556 8.47222 17.2222 8.88889 17.0833C12.9167 14.1667 12.7778 14.1667 13.8889 13.3333V12.5C13.8889 11.7331 13.2669 11.1111 12.5 11.1111ZM23.6111 6.94444H9.72222C8.95529 6.94444 8.33333 7.56641 8.33333 8.33333V9.72222H12.5C13.9414 9.72222 15.1298 10.8255 15.2652 12.2318L15.2778 12.2222V18.0556H23.6111C24.378 18.0556 25 17.4336 25 16.6667V8.33333C25 7.56641 24.378 6.94444 23.6111 6.94444ZM22.2222 12.5H19.4444V9.72222H22.2222V12.5ZM6.94444 8.33333C6.94444 6.80165 8.19054 5.55556 9.72222 5.55556H19.4444V1.38889C19.4444 0.621962 18.8225 0 18.0556 0H4.16667C3.39974 0 2.77778 0.621962 2.77778 1.38889V9.72222H6.94444V8.33333Z",
    fill: "url(#paint0_linear_634_2712)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_634_2712",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 22.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#156FBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f723cae7922846d0091e4d892a2c4309.svg";
export { ForwardRef as ReactComponent };